import { Button, ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary, FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup, TextField, Typography, withStyles } from 'material-ui';
import LeftArrowIcon from 'material-ui-icons/ArrowBack';
import RightArrowIcon from 'material-ui-icons/ArrowForward';
import EventIcon from 'material-ui-icons/Event';
import ExpandMoreIcon from 'material-ui-icons/ExpandMore';
import { DatePicker } from 'material-ui-pickers';
import { LinearProgress } from 'material-ui/Progress';
import moment from 'moment';
import React from 'react';
import { translate } from 'react-i18next';
import { isEdge } from '../../services/browserDetector';
import DropDownMenu from '../../ui/DropDownMenu';
import OLYWebPageComponent from '../OLYWebPageComponent';
import { handleDateChange } from '../Utils/handleDateChange';
import { listReservationById, listReservations, openPDFForReservation, updateMultiplePayments, errorMultiplePayments } from './reservationsServices';
import ReservationsTable from './Table/ReservationsTable';
import { getFEClientName } from '../../services/serviceAPIHelper';
import swal from 'sweetalert';

const styles = theme => ({
    column: {
        flexBasis: '33.33%',
    },
    columnall: {
        flexBasis: '77.77%',
        marginRight: '64px',
    },
    inputLabel: {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        color: theme.palette.text.inputLabel,
    },
    bookingFinderTitle: {
        color: theme.palette.primary.contrastText,
        fontSize: '16px'
    },
    expansionPanelFilter: {
        backgroundColor: theme.palette.primary.main,
    },
    expansionIcon: {
        color: theme.palette.primary.contrastText,
    },
    coloredIcon: {
        color: 'var(--primary-color) !important',
        marginRight: '-24px'
    },
    coloredIconIE: {
        color: 'var(--primary-color) !important',
        marginTop: '-20px',
        paddingBottom: '5px'
    },
    searchLink: {
        color: '#3155A1',
        cursor: 'pointer',
        transition: '.3s',
        '&:hover': {
            color: '#4374de'
        },
        '&:active': {
            color: '#3155A1'
        }
    }
});
/**
 * Componente que lista mis reservas
 */
class Reservations extends OLYWebPageComponent {
    constructor(props) {
        super(props);

        this.pageTitle = props.t('PAGE_TITLES.' + this.pageName);
        this.pageName = 'Reservations';
        this.pageReference = 'https://xcaleconsulting.atlassian.net/wiki/spaces/OL/pages/621740036/UI+-+Mis+Reservas';

        let dd = new Date();
        this.state = {
            data: [],
            searchType: 'localizador',
            FEclientName: getFEClientName(),
            loading: false,
            searchValue: '',
            filters: {
                clientLocator: '',
                reservationState: 'all', //vacio es todas
                dateType: 'FR',
                fromDate: moment(dd).subtract(2, 'days'),
                toDate: moment(dd).add(1, 'days'),
                clientName: '',
            },
            warning: false
        };
    }

    async componentDidMount() {
        const { confirmPayment, errorForPayment, paymentHash, t } = this.props;
        if (confirmPayment) {
            this.setState({ loading: true });

            await this.fireUpdateMultiplePayment(paymentHash);
            window.location.href = '#/bookings';        
        } else if (errorForPayment) {
            alert(t('PENDING_PAYMENTS.PAYMENT_ERROR'));

            this.fireErrorPayment(paymentHash);
            window.location.href = '#/bookings';   
        } 
        super.componentDidMount();
    }

    fireErrorPayment = (paymentHash) => {

        this.setState((prevState, props) => {
            return { hideIcon: false, processing: true, operationstatus: 'info', mode: 'indeterminate' };
        });

        return errorMultiplePayments(paymentHash)
            .then((result) => {
                this.setState({ hideIcon: false, processing: false });
            })
            .catch((e) => {
                this.setState({ hideIcon: false, processing: false });
            });
    }

    fireUpdateMultiplePayment = (paymentHash) => {

        return updateMultiplePayments(paymentHash)
            .then((result) => {
                alert(this.props.t('PENDING_PAYMENTS.PAYMENT_SUCCESSFULLY'));
            })
            .catch(async (e) => {
                window.location.href = '#/bookings';
                this.setState({ loading: false });
            await swal({
                    title: '',
                    text: this.props.t('PENDING_PAYMENTS.PAYMENT_WITH_ERROR'),
                    icon: 'warning',
                    buttons: true,
                    dangerMode: true,
                });
            });
    }

    sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    tableActionsMenuHandler = async (reserva, action) => {
        const actionaux = action.toLowerCase();
        const pdfTabs = ['bono', 'proforma'];
        if (pdfTabs.includes(actionaux)) {
            openPDFForReservation(this, reserva.olympiaLocator, action);
        }
        else if (actionaux === 'add_transfer') {
            let path = `#/search/transfers?from=${reserva.checkIn}&nights=${reserva.nights}&locator=${reserva.olympiaLocator}&adults=${reserva.totalAdults}&kidsAges=${reserva.totalKidsAges}`;
            window.open(path, '_blank');
        } else {
            const paths = ['bookings', reserva.olympiaLocator, actionaux];
            let path = /#/ + paths.join('/');
            window.open(path, '_blank');
        }
    };

    /**
     * Clean filter form
     *
     * @param {type} event
     * @returns void
     */
    cleanFilters = async event => {
        let dd = new Date();
        let filters = {
            clientLocator: '',
            reservationState: 'all', //vacio es todas
            dateType: 'FR',
            fromDate: moment(dd),
            toDate: moment(dd).add(1, 'days'),
            clientName: '',
        };
        await this.setState({ searchValue: '', filters });
    };

    handleSubmit = event => {
        this.setState({ loading: true });
        listReservations(this.state.filters)
            .then(data => {
                if (!data || (data && !data.length)) {
                    throw new Error(this.props.t('WSDL_RESPONSE_EMPTY'));
                }
                let id = 1;
                data.forEach(n => {
                    n.id = id++;
                });
                if (data) {
                    this.setState({
                        loading: false,
                        data: data,
                    });
                    try {
                        localStorage.setItem('reservas', JSON.stringify(data));
                    } catch (error) {
                        alert(error);
                    }
                }
            })
            .catch(reason => {
                alert(reason.message);
                this.setState({ data: [], loading: false });
            });
    };

    cantSearchById() {
        return this.state.localizadorID === '';
    }

    searchLocalizador = event => {
        switch (this.state.searchType) {
            case 'localizador':
                this.searchByLocalizador();
                break;

            case 'expediente':
                this.searchByExpediente();
                break;
            default:
                alert('Unsupported case ' + this.state.searchType);
                break;
        }
    }

    searchLastMonth = async () => {
        const fromDate = moment().subtract(30, 'days');
        const toDate = moment();

        await this.cleanFilters();

        await this.setState({
            filters: {
                ...this.state.filters,
                fromDate,
                toDate
            }
        });

        this.handleSubmit();
    }

    searchByExpediente = () => {
        if (!this.state.searchValue || /^\s*$/.test(this.state.searchValue)) {
            alert(this.props.t('BOOKINGS.ENTER_EXPEDIENT'));
            return;
        }
        this.setState({ loading: true });
        let filters = {
            clientLocator: this.state.searchValue
        };

        listReservations(filters).then(data => {
            let id = 1;
            //console.log(data);
            data.map(n => { n.id = id++; return n; });
            if (data) {
                this.setState({
                    loading: false,
                    data: data,
                });
            }
        }).catch(reason => {
            alert(reason.message);
            this.setState({ data: [], loading: false });
        });
    }

    searchByLocalizador = () => {
        if (!this.state.searchValue || /^\s*$/.test(this.state.searchValue)) {
            alert(this.props.t('BOOKINGS.ENTER_LOCATOR'));
            return;
        }
        this.setState({ loading: true });
        listReservationById(this.state.searchValue)
            .then(reservations => {
                let id = 1;
                reservations.map(r => { r.id = id++; });
                this.setState({
                    data: reservations,
                    loading: false
                });
            }).catch(e => {
                alert(e.message);
                this.setState({
                    data: [],
                    loading: false
                });
            });
    }

    handleSearchTypeChange = event => {
        this.setState({
            searchType: event.target.value,
            searchValue: ''
        });
    }

    render() {
        const { classes, t } = this.props;
        return (
            <div className='cmsBookings'>
                <ExpansionPanel defaultExpanded={true} style={{ marginTop: '0px' }} className={'thinText'}>
                    <ExpansionPanelSummary
                        expandIcon={<ExpandMoreIcon className={classes.expansionIcon} />}
                        className={classes.expansionPanelFilter}>
                        <Typography className={classes.bookingFinderTitle}>
                            {t('BOOKINGS.BOOKINGS_FINDER')}
                        </Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails style={{ padding: 0, height: '320px', marginBottom: '-12px' }}>
                        <div
                            className={classes.column}
                            style={{
                                backgroundColor: '#e5e5e5',
                                margin: '0 auto',
                                display: 'flex',
                                alignItems: 'center',
                            }}>
                            <Grid
                                container
                                direction="row"
                                style={{ padding: '0px 20px 20px 20px', margin: '0 auto' }}>
                                <FormControl component="fieldset">
                                    <FormLabel component="legend" style={{ fontSize: '12px' }} className={classes.inputLabel}>{t('BOOKINGS.SEARCH_FOR')}</FormLabel>
                                    <RadioGroup
                                        aria-label="searchType"
                                        name="searchType" value={this.state.searchType}
                                        onChange={this.handleSearchTypeChange}>
                                        <FormControlLabel value="localizador" control={<Radio />} label={t('BOOKINGS.LOCATOR')} />
                                        <FormControlLabel value="expediente" control={<Radio />} label={t('BOOKINGS.AGENCY_LOCATOR')} />
                                    </RadioGroup>
                                </FormControl>
                                <TextField value={this.state.searchValue}
                                    onChange={event => {
                                        this.setState({ searchValue: String(event.target.value) });
                                    }}
                                    InputLabelProps={{
                                        shrink: true,
                                        className: classes.inputLabel,
                                    }}
                                    style={{ width: '95%' }}
                                    placeholder={t('BOOKINGS.ENTER_LOCATOR_EXPEDIENT', { value: this.state.searchType })}
                                />
                                <div style={{width: '100%', display: 'flex'}}>
                                    <Button
                                        variant="raised"
                                        onClick={this.searchLocalizador}
                                        disabled={this.state.loading}
                                        color="primary"
                                        style={{ margin: '0 auto', marginTop: '16px' }}>
                                        {t('BOOKINGS.SEARCH_BUTTON')}
                                    </Button>
                                </div>

                                <div style={{display: 'flex', flex: 1, width: '100%', marginTop: '10px'}}>
                                    <a onClick={this.searchLastMonth} className={classes.searchLink + ' fw-600'}>
                                        {t('BOOKINGS.SEARCH_LAST_BOOKINGS')}
                                    </a>
                                </div>
                            </Grid>
                        </div>

                        <div className={classes.columnall}>
                            <Grid
                                container
                                direction="row"
                                style={{ padding: '32px' }}>
                                <Grid item xs={6}>
                                    <DropDownMenu
                                        label={t('BOOKINGS.DATE')}
                                        value={this.state.filters.dateType}
                                        selection={this.state.filters.dateType}
                                        onChange={value => {
                                            let filters = this.state.filters;
                                            filters.dateType = value;
                                            this.setState({ filters });
                                        }}
                                        InputLabelProps={{
                                            className: classes.inputLabel,
                                        }}
                                        width={'95%'}
                                        menuOptions={[
                                            { label: t('BOOKINGS.DATE_CHECKIN'), value: 'FE' },
                                            { label: t('BOOKINGS.DATE_RESERVED'), value: 'FR' },
                                        ]}
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <DatePicker
                                        keyboard
                                        onChange={value => {
                                            handleDateChange('fromDate', value, this);
                                        }}
                                        label={t('COMMON.FROM')}
                                        format={'DD/MM/YYYY'}
                                        value={this.state.filters.fromDate}
                                        autoOk
                                        style={{ width: '90%' }}
                                        InputLabelProps={{
                                            className: classes.inputLabel,
                                        }}
                                        leftArrowIcon={<LeftArrowIcon />}
                                        rightArrowIcon={<RightArrowIcon />}
                                        keyboardIcon={
                                            <EventIcon
                                                className={isEdge() ? classes.coloredIconIE : classes.coloredIcon}
                                            />
                                        }
                                        animateYearScrolling={false}
                                        invalidDateMessage={t('COMMON.INVALID_FORMAT')}
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <DatePicker
                                        keyboard
                                        onChange={value => {
                                            handleDateChange('toDate', value, this);
                                        }}
                                        label={t('COMMON.TO')}
                                        format={'DD/MM/YYYY'}
                                        value={this.state.filters.toDate}
                                        autoOk
                                        style={{ width: '90%' }}
                                        InputLabelProps={{
                                            className: classes.inputLabel,
                                        }}
                                        leftArrowIcon={<LeftArrowIcon />}
                                        rightArrowIcon={<RightArrowIcon />}
                                        keyboardIcon={
                                            <EventIcon
                                                className={isEdge() ? classes.coloredIconIE : classes.coloredIcon}
                                            />
                                        }
                                        animateYearScrolling={false}
                                        invalidDateMessage={t('COMMON.INVALID_FORMAT')}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        label={t('BOOKINGS.CLIENT_NAME')}
                                        value={this.state.filters.clientName}
                                        onChange={event => {
                                            let filters = this.state.filters;
                                            filters.clientName = event.target.value;
                                            this.setState({ filters });
                                        }}
                                        style={{ width: '96%' }}
                                        placeholder={t('BOOKINGS.ENTER_NAME')}
                                        InputLabelProps={{
                                            shrink: true,
                                            className: classes.inputLabel,
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <DropDownMenu
                                        label={t('BOOKINGS.STATE')}
                                        selection={this.state.filters.reservationState}
                                        onChange={value => {
                                            let filters = this.state.filters;
                                            filters.reservationState = value;
                                            this.setState({ filters });
                                        }}
                                        InputLabelProps={{
                                            className: classes.inputLabel,
                                        }}
                                        width={'95%'}
                                        menuOptions={[
                                            { label: t('BOOKINGS.ALL'), value: 'all' },
                                            { label: t('BOOKINGS.BOOKED'), value: 'R' },
                                            { label: t('BOOKINGS.CANCELED'), value: 'C' },
                                            { label: t('BOOKINGS.ON_REQUEST'), value: 'P' },
                                            { label: t('BOOKINGS.BILLED'), value: 'F' },
                                        ]}
                                    />
                                </Grid>
                                <Grid container item wrap="nowrap" spacing={8} xs={12}>
                                    <div style={{ margin: '0 auto' }}>
                                        <Button variant="raised"
                                            onClick={this.cleanFilters}
                                            disabled={this.state.loading}
                                            color="secondary"
                                            style={{ marginRight: '32px', right: '10px' }}>
                                            {t('BOOKINGS.CLEAN_FILTER_BUTTON')}
                                        </Button>
                                        <Button variant="raised"
                                            onClick={this.handleSubmit}
                                            disabled={this.state.loading}
                                            color="primary">
                                            {t('BOOKINGS.SEARCH_BUTTON').toUpperCase()}
                                        </Button>
                                    </div>
                                </Grid>
                            </Grid>
                        </div>
                    </ExpansionPanelDetails>
                </ExpansionPanel>
                <div style={{ margin: '5px' }}>
                    {this.state.loading ? <LinearProgress className="cmsProgressBar" /> : ''}
                    <ReservationsTable
                        data={this.state.data}
                        user={this.currentUser}
                        clientName={this.state.FEclientName}
                        history={this.props.history}
                        actionhandler={this.tableActionsMenuHandler}
                        menuactionslabels={{
                            VIEW: t('BOOKINGS.VIEW_BOOKING'),
                            EDIT: t('BOOKINGS.EDIT'),
                            CANCEL: t('BOOKINGS.CANCEL'),
                            MODIFY: t('MODIFY_BOOKING.MODIFY'),
                            // BONO: 'Descargar Bono',
                            BONO: t('BOOKINGS.VIEW_VOUCHER'),
                            // PROFORMA: 'Descargar Proforma'
                            PROFORMA: t('BOOKINGS.VIEW_PROFORMA'),
                            ADD_TRANSFER: t('BOOKINGS.ADD_TRANSFER'),
                            PAY_RESERVATION: t('COMMON.PAY_RESERVATION')
                        }}
                    />
                </div>              
            </div>
        );
    }
}
export default translate('translations')(withStyles(styles)(Reservations));


// WEBPACK FOOTER //
// ./src/components/Reservations/Reservations.js